import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  numberMontoInvertir: Yup.number()
    .min(500, 'El valor no puede ser menos a 500')
    .typeError("")
    .transform((value, originalValue) => {
        if (typeof originalValue === 'string') {
          return originalValue.trim() === '' || isNaN(value) ? '' : value;
        }
        return isNaN(value) ? '' : value;
      })
    .required('Este campo es obligatorio'),
  numberCantDias: Yup.number()
    .min(30, 'El valor no puede ser menos a 30')
    .max(365, 'El valor no puede ser mayor a 365')
    .typeError("")
    .transform((value, originalValue) => {
        if (typeof originalValue === 'string') {
          return originalValue.trim() === '' || isNaN(value) ? '' : value;
        }
        return isNaN(value) ? '' : value;
      })
    .required('Este campo es obligatorio'),
});
